import React, { useState } from "react";
import styles from "./ForgotPasswordModal.module.css";

const ForgotPasswordModal = ({ onClose, onBackToLogin }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  // 🔹 Беремо API URL з .env
  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("📤 Надсилаю запит на відновлення паролю для:", email);

      const res = await fetch(
        `${API_URL}/api/customers/request-password-reset`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include", // 🔹 щоб працювали cookies
          body: JSON.stringify({ email }),
          mode: "cors", // ✅ додай це
        }
      );

      const data = await res.json().catch(() => ({})); // якщо не JSON — не падаємо

      console.log("📥 Відповідь сервера:", res.status, data);

      if (!res.ok) {
        throw new Error(data?.message || "Не вдалося надіслати інструкції.");
      }

      setSuccess(true);
    } catch (err) {
      console.error("❌ Помилка відновлення паролю:", err);
      setError(err.message || "Сталася помилка. Спробуйте ще раз.");
    } finally {
      setLoading(false);
    }
  };

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdrop}>
      <div className={styles.modalWindow}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Закрити"
        >
          ×
        </button>
        <h3 className={styles.formTitle}>Відновлення паролю</h3>

        {success ? (
          <div className={styles.successMessage}>
            Якщо такий email зареєстровано, інструкції для відновлення паролю
            надіслані на вашу пошту.
            <div className={styles.switchLine}>
              <span className={styles.link} onClick={onBackToLogin}>
                Повернутися до входу
              </span>
            </div>
          </div>
        ) : (
          <form
            className={styles.form}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div className={styles.field}>
              <label htmlFor="forgotEmail">Вкажіть електронну пошту</label>
              <input
                className={styles.input}
                id="forgotEmail"
                name="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                disabled={loading}
              />
            </div>

            {error && <div className={styles.error}>{error}</div>}

            <button className={styles.submit} type="submit" disabled={loading}>
              {loading ? "Відправка..." : "Надіслати інструкції"}
            </button>

            <div className={styles.switchLine}>
              <span className={styles.link} onClick={onBackToLogin}>
                Повернутися до вікна авторизації
              </span>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
